module.exports = __webpack_public_path__ + "assets/img/case-country3-new.fadb744c.png";